import PropTypes from 'prop-types';
import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


class Footer extends React.Component {
    static propTypes = {
		session: PropTypes.object,
	};

    render() {

		const { loggedIn } = this.props;

		return (

			<footer className="main-footer">
	            <div className="container">
	                
	            </div>
	        </footer>

		)
	}
}

const mapStateToProps = state => ({
    loggedIn: state.session.user && 'ID' in state.session.user,
    notifications: state.notifications,
    //isSession: 'ID' in state.user
});

const mapDispatchToProps = dispatch => bindActionCreators({  }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( Footer );



// WEBPACK FOOTER //
// ./src/js/components/Footer/index.js